// Classe de base contenant l'ensemble des libellés traductibles de l'application
export class AppLabels {
	// Général
	static submit: string = "Valider";
	static cancel: string = "Annuler";
	static ok: string = "OK";
	static okTimeOut: string = AppLabels.ok + " (%%t%%)";
	static yes: string = "Oui";
	static no: string = "Non";
	static back: string = "Retour";
	static previous: string = "Précédent";
	static close: string = "Fermer";

	static loading: string = "Chargement en cours...";
	static authenticateError: string = "Erreur d'authentification";

	static viewAdminTitle: string = "Configuration de l'application";
	static viewHomeTitle: string = "Menu général";
	static unauthenticated: string = "Non authentifié";

	static configLoginLabelsTitle: string = "Configuration des textes de la page login";
	static configShowX3: string = "Afficher le dossier X3";
	static configShowVersion: string = "Afficher le n° de version de Karma";
	static configActiveLanguage: string = "Langue active";
	static configSoundPlayTitle: string = "Liste des sons chargés";
	static configIconsTitle: string = "Liste des icônes chargées";

	static selectListTitle: string = "Sélectionnez un élément";
	static errorTitle: string = "Erreur";
	static warningTitle: string = "Avertissement";
	static infoTitle: string = "Information";

	static noActiveLangError: string = "Il faut au moins sélectionner une langue";

	static confirmTitle: string = "Confirmation";

	static listCol1Title: string = "Valeur";
	static listCol2Title: string = "Description";

	// View NotFound
	static pageNotFoundTitle: string = "404 - Page not found";
	static pageNotFoundDetail: string = "La page ou la ressource demandée n'a pas été trouvé. Contactez votre administrateur";

	static saveConfigError: string = "Erreur lors de l'enregistrement de la configuration";
	static saveConfigOk: string = "Configuration enregistrée.";

	static abandonUpdatesWarning: string = "Les modifications vont etre perdues";
		
	static tabSortDateFormat: string = "DD-MM-YYYY";
	static inlineStyleError: string = "Une erreur a été rencontrée lors de l'interprétation d'un style conditionnel du tableau";
	static sessionTimeOutError: string = "Votre session a expiré";
	static criticalError: string = "L'application a rencontréune erreur irrécupérable et doit s'arrêter. Vous allez être redirigé vers la page d'authentification";
	static printDialogTitle: string = "Etat de l'impression";
	static printDialogContent = "Impression lancée";

	static jsonErrorTitle = "JSON Attributes Error(s)";
	static jsonErrorContent = "Une erreur a été détecté des les attributs des champs.La page peut ne pas s'afficher correctement";
	static jsonErrorContentFullZone = "Une erreur a été détecté dans l'attribut %%0%% de la zone %%1%%";
	static jsonErrorContentFullBtn = "Une erreur a été détecté dans l'attribut %%0%% du bouton %%1%%";
	static inputErrorTitle = "Erreur lors de la saisie";
	static inputErrorDetail = "Corrigez les erreurs avant de poursuivre";
	static sessionWillTimeout = "Votre session va expirer. Souhaiter vous la prolonger ?";

	static fieldTooShort = "Longueur du champ insuffisante";
	static fieldTooLong = "Taille du champ trop grande";
	static mandatoryField = "Saisie obligatoire";
	static valueTooSmall = "Valeur trop faible";
	static valueTooHigh = "Valeur trop grande";
	static invalidDate = "Date invalide";
	static sessionInactivityTimeout = "Aucune activité. Souhaitez-vous resté connecté ?"

	static keepLogged = "Rester connecté"
	static Logout = "Déconnexion"
	static enterPassword = "Entrez à nouveau votre mot de passe pour l'associer au QR Code :"
	static authenticationLoginSummary = "QR Code permettant la connexion de : "
	static noData = "Pas de données"
	static selectActionTitle = "Sélectionnez une action";

	static multiScanTitle = "Saisies multiples par scan";

	static nonUniqueInput = "Valeur déjà présente en liste";

	static codBarValidError = "Le code barre lu ne correSpond pas à une valeur attendue";
	static codBarValidParseError = "La formule de validation du code barre comporte un erreur (champ %%0%%)";
	static validCondAttrParseError = "La formule de validation de l'attribut VALIDCON comporte une erreur";
	static takePicture = "Prendre";

	//stresseur
	static targetPool = "Pool cible";
	static webService = "Web service";
	static callsNumber = "Nombre d'appels";
	static interval = "Intervalle";
	static XMLEntry = "Entrée XML";
	static run = "Lancer";
	static id = "Id";
	static start = "Début";
	static end = "Fin";
	static durationms = "Durée (ms)";
	static serverDuration = "Durée serveur";
	static status = "Statut";
	static serverStatus = "Statut serveur";
	static message = "Message";

	static newPool = "Nouveau pool";
	static newMapping = "Nouveau mapping";
	static itemAlreadyInList = "Element déjà présent en liste";
	static selectFromList = "Sélectionner un élément";
	static primaryPool = "Pool principal";
	static secondaryPool = "Pool de secours";
	static webServiceName = "Nom du WS";
	static poolMappingTable = "Liste des mappings Web service/Pool";
	static add = "Ajouter";
	static apply = " Appliquer les changements";
	static action = "Action";
	static pool = "Pool";
	static poolName = "Nom du pool";
	static defaultPoolList = "Liste des pools par défaut";
	static canceled = "Annulé";
	static inProgress = "En cours";
	static wait = "En attente";
	static stressTitle = "Stresseur"
	static showAsGraph = "Afficher le graphique";

	static pie = "Camembert";
	static bar = "Histogramme";
	static line = "Ligne"

	static alias = "Alias";
	static autoStart = "Auto start";
	static manualStop = "Manual stop";
	static maxSize = "Max size";
	static initSize = "Init size";
	static unusedTimeout = "Unused timeout (mn)"
	static lifeTimeout = "Life timeout (mn)"
	static stop = "Stop";
	static severity = "Severity";
	static Yes_short = "O";
	static No_short = "N";
	static x3PoolsTitle = "X3 Pools"

	static locksDetectedConfirm = "Des verrous ont été détectés sur d'autres sessions. Souhaitez-vous les supprimer ?";
	static locksDetected = "Verrous détectés";
}

